export function useFile() {
  const downloadUrl = (url: string): void => {
    const link = document.createElement("a");
    link.href = url + "?download=true";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dataURLtoFile = (data: string, filename: string): File => {
    const chunks = data.split(",");
    const mime = (chunks[0].match(/:(.*?);/) || [])[1];
    const binary = atob(chunks[1]);
    let index = binary.length;
    const bytes = new Uint8Array(index);

    while (index--) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new File([bytes], filename, { type: mime });
  };

  return { downloadUrl, dataURLtoFile };
}
